import './JoinUs.css';
import './ResponsiveJoinUs.css';
import { getTranslatedText as translate } from '../Localization/Translation';
import { useSelector } from 'react-redux';
import { useBetween } from 'use-between';
import JoinUsPic from "./joinUs.jpg";

function JoinUs() {
    const { locale, joinRef } = useBetween(
      useSelector((state) => state.useSharedLang)
    );

    return (
      <div className="JoinUs" ref={joinRef}>
        <div className="section-name">{translate("joinUs-header", locale)}</div>

        <div
          className="JoinUs-container row"
          dir={locale === "AR" ? "rtl" : "ltr"}
        >
          {/* Form */}
          <div className="form-join col-md" dir="auto">
            <div className="form-text">
              {translate("first-joinUS-content", locale)}
            </div>
            <div>
              <a href="#" className="btn btn-primary btn-start">
                {translate("first-joinUs-button", locale)}
              </a>
              <a href="#" className="btn btn-secondary">
                {translate("second-joinUs-button", locale)}
              </a>
            </div>
          </div>

          {/* Pic */}
          <div className="col-md">
            <div className="join-pic-container">
              <img src={JoinUsPic} alt="..." className="join-pic" />
            </div>
          </div>
        </div>
      </div>
    );
}

export default JoinUs;
